import { TenantEntity } from '../TenantEntity'

export class SpecialGoods extends TenantEntity {
  get danClassNo() {
    return this._data.danClassNo
  }
  set danClassNo(danClassNo) {
    this._data.danClassNo = danClassNo
  }
  get danUNNo() {
    return this._data.danUNNo
  }
  set danUNNo(danUNNo) {
    this._data.danUNNo = danUNNo
  }
  get danPacking() {
    return this._data.danPacking
  }
  set danPacking(danPacking) {
    this._data.danPacking = danPacking
  }
  get danLable() {
    return this._data.danLable
  }
  set danLable(danLable) {
    this._data.danLable = danLable
  }
  get danEMS() {
    return this._data.danEMS
  }
  set danEMS(danEMS) {
    this._data.danEMS = danEMS
  }
  get danPoint() {
    return this._data.danPoint
  }
  set danPoint(danPoint) {
    this._data.danPoint = danPoint
  }
  get danIsolation() {
    return this._data.danIsolation
  }
  set danIsolation(danIsolation) {
    this._data.danIsolation = danIsolation
  }
  get danMfagNo() {
    return this._data.danMfagNo
  }
  set danMfagNo(danMfagNo) {
    this._data.danMfagNo = danMfagNo
  }
  get dan24man() {
    return this._data.dan24man
  }
  set dan24man(dan24man) {
    this._data.dan24man = dan24man
  }
  get dan24tel() {
    return this._data.dan24tel
  }
  set dan24tel(dan24tel) {
    this._data.dan24tel = dan24tel
  }
  get responsibleParty() {
    return this._data.responsibleParty
  }
  set responsibleParty(responsibleParty) {
    this._data.responsibleParty = responsibleParty
  }
  get danPickTime() {
    return this._data.danPickTime
  }
  set danPickTime(danPickTime) {
    this._data.danPickTime = danPickTime
  }
  get danSeaPullution() {
    return this._data.danSeaPullution
  }
  set danSeaPullution(danSeaPullution) {
    this._data.danSeaPullution = danSeaPullution
  }
  get gohTier() {
    return this._data.gohTier
  }
  set gohTier(gohTier) {
    this._data.gohTier = gohTier
  }
  get gohHanger() {
    return this._data.gohHanger
  }
  set gohHanger(gohHanger) {
    this._data.gohHanger = gohHanger
  }
  get gohRopes() {
    return this._data.gohRopes
  }
  set gohRopes(gohRopes) {
    this._data.gohRopes = gohRopes
  }
  get gohKnots() {
    return this._data.gohKnots
  }
  set gohKnots(gohKnots) {
    this._data.gohKnots = gohKnots
  }
  get gohReformCost() {
    return this._data.gohReformCost
  }
  set gohReformCost(gohReformCost) {
    this._data.gohReformCost = gohReformCost
  }
  get reefVentilation() {
    return this._data.reefVentilation
  }
  set reefVentilation(reefVentilation) {
    this._data.reefVentilation = reefVentilation
  }
  get reefHumidity() {
    return this._data.reefHumidity
  }
  set reefHumidity(reefHumidity) {
    this._data.reefHumidity = reefHumidity
  }
  get reefPTI() {
    return this._data.reefPTI
  }
  set reefPTI(reefPTI) {
    this._data.reefPTI = reefPTI
  }
  get reefMeasure() {
    return this._data.reefMeasure
  }
  set reefMeasure(reefMeasure) {
    this._data.reefMeasure = reefMeasure
  }
  get reefTemperature() {
    return this._data.reefTemperature
  }
  set reefTemperature(reefTemperature) {
    this._data.reefTemperature = reefTemperature
  }
  get reefHighestTemp() {
    return this._data.reefHighestTemp
  }
  set reefHighestTemp(reefHighestTemp) {
    this._data.reefHighestTemp = reefHighestTemp
  }
  get reefLowestTemp() {
    return this._data.reefLowestTemp
  }
  set reefLowestTemp(reefLowestTemp) {
    this._data.reefLowestTemp = reefLowestTemp
  }
  get reefContainerYard() {
    return this._data.reefContainerYard
  }
  set reefContainerYard(reefContainerYard) {
    this._data.reefContainerYard = reefContainerYard
  }
  get reefDeliverTime() {
    return this._data.reefDeliverTime
  }
  set reefDeliverTime(reefDeliverTime) {
    this._data.reefDeliverTime = reefDeliverTime
  }
  get overFront() {
    return this._data.overFront
  }
  set overFront(overFront) {
    this._data.overFront = overFront || 0
  }
  get overBack() {
    return this._data.overBack
  }
  set overBack(overBack) {
    this._data.overBack = overBack || 0
  }
  get overLeft() {
    return this._data.overLeft
  }
  set overLeft(overLeft) {
    this._data.overLeft = overLeft || 0
  }
  get overRight() {
    return this._data.overRight
  }
  set overRight(overRight) {
    this._data.overRight = overRight || 0
  }
  get overHeight() {
    return this._data.overHeight
  }
  set overHeight(overHeight) {
    this._data.overHeight = overHeight || 0
  }
  get danNo() {
    return this._data.danNo
  }
  set danNo(danNo) {
    this._data.danNo = danNo
  }
  get chineseCommodity() {
    return this._data.chineseCommodity
  }
  set chineseCommodity(chineseCommodity) {
    this._data.chineseCommodity = chineseCommodity
  }
  get englishCommodity() {
    return this._data.englishCommodity
  }
  set englishCommodity(englishCommodity) {
    this._data.englishCommodity = englishCommodity
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get correctTransportName() {
    return this._data.correctTransportName
  }
  set correctTransportName(correctTransportName) {
    this._data.correctTransportName = correctTransportName
  }
  get secondarySpecialGoods() {
    return this._data.secondarySpecialGoods
  }
  set secondarySpecialGoods(secondarySpecialGoods) {
    this._data.secondarySpecialGoods = secondarySpecialGoods
  }
  get grossWeight() {
    return this._data.grossWeight
  }
  set grossWeight(grossWeight) {
    this._data.grossWeight = grossWeight || 0.0
  }
  get neatWeight() {
    return this._data.neatWeight
  }
  set neatWeight(neatWeight) {
    this._data.neatWeight = neatWeight || 0.0
  }
  get outerPackagingType() {
    return this._data.outerPackagingType
  }
  set outerPackagingType(outerPackagingType) {
    this._data.outerPackagingType = outerPackagingType
  }
  get outerPackagingQuantity() {
    return this._data.outerPackagingQuantity
  }
  set outerPackagingQuantity(outerPackagingQuantity) {
    this._data.outerPackagingQuantity = outerPackagingQuantity || 0
  }
  get innerPackagingType() {
    return this._data.innerPackagingType
  }
  set innerPackagingType(innerPackagingType) {
    this._data.innerPackagingType = innerPackagingType
  }
  get innerPackagingQuantity() {
    return this._data.innerPackagingQuantity
  }
  set innerPackagingQuantity(innerPackagingQuantity) {
    this._data.innerPackagingQuantity = innerPackagingQuantity
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get packingCode() {
    return this._data.packingCode
  }
  set packingCode(packingCode) {
    this._data.packingCode = packingCode
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get temperatureUnit() {
    return this._data.temperatureUnit
  }
  set temperatureUnit(temperatureUnit) {
    this._data.temperatureUnit = temperatureUnit
  }
  get email() {
    return this._data.email
  }
  set email(email) {
    this._data.email = email
  }
  get fax() {
    return this._data.fax
  }
  set fax(fax) {
    this._data.fax = fax
  }
  get flashPointUnit() {
    return this._data.flashPointUnit
  }
  set flashPointUnit(flashPointUnit) {
    this._data.flashPointUnit = flashPointUnit
  }
  get hazardForm() {
    return this._data.hazardForm
  }
  set hazardForm(hazardForm) {
    this._data.hazardForm = hazardForm
  }
  get emergencyReportingTime() {
    return this._data.emergencyReportingTime
  }
  set emergencyReportingTime(emergencyReportingTime) {
    this._data.emergencyReportingTime = emergencyReportingTime
  }
}
